<div class="subindusties">
  <h6 translationEditableDirective="SUB_INDUSTRIES">
    {{ 'SUB_INDUSTRIES' | translate }}
  </h6>
  <form-row
    (onDelete)="handleRowDelete(i)"
    [inline]="true"
    *ngFor="let subindustry of data; let i = index"
  >
    <div class="field is-narrow">
      <label class="label is-small" translationEditableDirective="NAME">{{
        'NAME' | translate
      }}</label>
      <div class="control">
        <input
          class="input is-small"
          name="name"
          type="text"
          (input)="handleFieldChange($event, i)"
          [value]="subindustry.get('name')"
        />
      </div>
    </div>
    <div class="field is-narrow">
      <label class="label is-small" translationEditableDirective="FIXED_TAX">{{
        'FIXED_TAX' | translate
      }}</label>
      <div class="control">
        <number-input
          inputClass="input is-small"
          name="fixedTax"
          step="1"
          (input)="handleFieldChange($event, i)"
          [value]="subindustry.get('fixedTax')"
        />
      </div>
    </div>
  </form-row>
  <div style="margin-bottom: 20px">
    <button
      type="button"
      (click)="handleRowAdd()"
      class="button is-small is-info"
      translationEditableDirective="ADD_NEW_SUB_INDUSTRY"
    >
      {{ 'ADD_NEW_SUB_INDUSTRY' | translate }}
    </button>
  </div>
</div>
